(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["age-gate"] && !Shopify.designMode) return;
  try {
    (function () {
    var STORAGE_KEY = 'mg_age_verified';
    var gate = document.getElementById('age-gate');

    function isVerified() {
      try {
        return localStorage.getItem(STORAGE_KEY) === '1';
      } catch (e) {
        return false;
      }
    }

    function setVerified() {
      try {
        localStorage.setItem(STORAGE_KEY, '1');
      } catch (e) {}
    }

    function showGate() {
      gate.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      document.getElementById('age-gate-confirm').focus();
    }

    // Tell the rest of the page the gate is no longer covering the view. The hero
    // video waits for this so a first-time visitor is not downloading a film
    // behind an overlay they have not dismissed yet (GUI-136). Additive only:
    // nothing about verification depends on anyone listening.
    function announceDismissed() {
      document.dispatchEvent(new CustomEvent('mg:age-verified', { bubbles: true }));
    }

    function hideGate() {
      gate.setAttribute('hidden', '');
      document.body.style.overflow = '';
      announceDismissed();
    }

    if (!isVerified()) {
      showGate();
    } else {
      // Returning visitor: the gate was never shown, so hideGate() never runs.
      // Listeners that load after this point must not rely on the event — they
      // should also test the gate's `hidden` attribute directly.
      announceDismissed();
    }

    document.getElementById('age-gate-confirm').addEventListener('click', function () {
      setVerified();
      hideGate();
    });

    document.getElementById('age-gate-deny').addEventListener('click', function () {
      // Send the visitor back where they came from. On a direct landing there is
      // nothing to go back to, so the gate simply stays up — content is never shown.
      window.history.back();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    (function () {
    function init() {
      var bar = document.querySelector('[data-sticky-atc]');
      if (!bar) return;

      // The real button. Everything below drives it rather than replacing it.
      var real = document.querySelector('[data-add-to-cart]');
      if (!real) {
        bar.remove();
        return;
      }

      var proxy = bar.querySelector('[data-sticky-atc-button]');
      var priceOut = bar.querySelector('[data-sticky-atc-price]');

      proxy.addEventListener('click', function () {
        real.click();
      });

      // Show the bar whenever the real button is off screen, in either
      // direction.
      //
      // The first cut only showed it once the button had scrolled past
      // upwards, on the theory that a buy button before the photographs is
      // clutter. Measured on this layout, that was wrong: the button sits at
      // y=867 against an 844px viewport, so it is 23px below the fold, and the
      // bar did not appear until 1000px of scrolling — 43% down the page, past
      // the entire gallery. That stretch is exactly where someone decides to
      // buy, and there was no buy button on screen for any of it.
      var observer = new IntersectionObserver(
        function (entries) {
          setVisible(!entries[0].isIntersecting);
        },
        { threshold: 0 },
      );
      observer.observe(real);

      function setVisible(on) {
        bar.classList.toggle('is-visible', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        // Out of the tab order while hidden: the real button is the one that
        // should be reachable, and two identical controls confuse a screen
        // reader more than they help.
        proxy.setAttribute('tabindex', on ? '0' : '-1');
      }

      // Mirror the real button's disabled state. Solace toggles it when the
      // variant changes, and a sticky button that stays enabled on a sold-out
      // variant is worse than no sticky button.
      var stateWatcher = new MutationObserver(function () {
        proxy.disabled = real.disabled;
      });
      stateWatcher.observe(real, { attributes: true, attributeFilter: ['disabled'] });

      // Mirror the price the same way rather than recomputing it, so currency
      // formatting, unit prices and any discount the theme applies stay
      // consistent with what is shown above.
      var priceEl = document.querySelector('.product__price');
      if (priceEl && priceOut) {
        var priceWatcher = new MutationObserver(function () {
          var text = priceEl.textContent.trim();
          if (text) priceOut.textContent = text;
        });
        priceWatcher.observe(priceEl, { childList: true, subtree: true, characterData: true });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
